import workbooksDb from '@/services/firestore/workbooks';
import teamsDb from '@/services/firestore/team';
export default function useTeamsWorkbooks(db, teamId) {
  // Lookup all workbooks belonging to user's team
  const teamRef = teamsDb.createDocRef(teamId || 'na-team-id');
  const query = workbooksDb.query(db, {
    team: ['==', teamRef] // within team

  });
  return query;
}